export const addGtmConsentListener = () => {
  // Called from GTM template to set callback to be executed when user consent is provided.
  // Callback to execute on user consent
  window.gtmConsentListener = (callback) => {
    consentListenersGtm.push(callback)
  }
}

const consentListenersGtm = []

// Called when user grants/denies consent.
// Object containing user consent settings.
export const gtmOnConsentChange = (consent) => {
  consentListenersGtm.forEach((callback) => {
    callback(consent)
  })
}
